export const findFilterByField = (field: FieldDto, filters: Filter[]) => {
    const matchedFilter = filters.find((filter) => filter.field?._sid === field._sid)
    return matchedFilter
}
